import PushersView from "../PushersView.vue";
import PusherList from "../Pages/PusherList.vue";
import PusherEditor from "../Pages/PusherEditor.vue";
import PusherUpload from '../Pages/PusherUpload.vue'

const routes = [
  {
    path: 'impulsadores',
    component: PushersView,
    children: [
      {
        path: '',
        name: 'celulares-pushers-list',
        roles: ['impulsador_lista'],
        component: PusherList
      },
      {
        path: 'crear',
        name: 'celulares-pushers-create',
        roles: ['impulsador_lista_agregar'],
        component: PusherEditor
      },
      {
        path: ':id/editar',
        name: 'celulares-pushers-edit',
        roles: ['impulsador_lista_editar'],
        component: PusherEditor,
      },
      {
        path: 'carga',
        name: 'celulares-pushers-upload',
        roles: ['impulsador_carga_masiva'],
        component: PusherUpload
      }
    ]
  },
]

export default routes
